import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import {
  Form,
  FormHeader,
  FormFooter,
  FormBack,
  TextfieldElement,
  SelectElement,
  Button,
  CheckboxesElement,
  FormMandatoryPrompt,
  AutocompleteTextfieldElement
} from "cw-styleguide-react";
import i18n from "../../../../i18n";
import withAssets from "../../../../components/hoc/withAssets";
import { STEP_QUALIFICATION_VIEW } from "../../../../constants";
import ErrorNavigation from '../../../../components/ErrorNavigation';

class QualificationsCreateStep extends Component {

  render() {
    return (
      <Fragment>
        <Form multi={true}>
          <ErrorNavigation field={this.props.errorActiveField} handleClearActiveErrors={this.props.handleClearActiveErrors} />
          <FormHeader title={this.props.t('local:view.courses.create.tabs.qualifications.step.create.title')}>
            <FormMandatoryPrompt />
          </FormHeader>

          {/* Qualification title */}
          <div id={'manualQualifications.' + this.props.manualQualificationId + '.title_' + this.props.inputLanguage} />
          <TextfieldElement
            size={'medium'}
            id={'qualificationTitle_' + this.props.inputLanguage}
            name={'qualificationTitle_' + this.props.inputLanguage}
            label={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.qualificationTitle.label')}
            description={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.qualificationTitle.description')}
            value={this.props['qualificationTitle_' + this.props.inputLanguage]}
            errors={this.props.errors['manualQualifications.' + this.props.manualQualificationId + '.title_' + this.props.inputLanguage]}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter}
            required={true} />

          {/* Qualification type */}
          <SelectElement
            size={'medium'}
            id={'qualificationType'}
            name={'qualificationType'}
            label={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.qualificationType.label')}
            description={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.qualificationType.description')}
            options={[{
              value: '',
              label: this.props.t('styleguide:forms.pleaseSelect')
            }].concat(this.props.courses.assets.qualifications.qualificationType[i18n.language])}
            value={this.props['qualificationType']}
            onChange={this.props.handleChange}
            onKeyPress={this.context.preventDefaultOnEnter}
            required={true} />

          {/* Qualification level */}
          <CheckboxesElement
            id={'qualificationLevel'}
            name={'qualificationLevel'}
            label={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.qualificationLevel.label')}
            description={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.qualificationLevel.description')}
            options={this.props.courses.assets.qualifications.qualificationLevel[i18n.language]}
            value={this.props['qualificationLevel']}
            onChange={this.props.handleChange} />

          {/* Awarding body */}
          <AutocompleteTextfieldElement
            size={'large'}
            id={'awardingBody'}
            name={'awardingBody'}
            label={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.awardingBody.label')}
            placeholder={this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.awardingBody.placeholder')}
            options={this.props.courses.assets.qualifications.awardingBody[this.props.inputLanguage].map(body => ({ id: body.value, value: body.label }))}
            value={this.props.courses.assets.qualifications.awardingBody[this.props.inputLanguage].find(body => body.value === this.props.awardingBody)?.label}
            errors={this.props.errors.awardingBody}
            onChange={(e) => {
              if (e.target.name === 'awardingBodyId') {
                this.props.handleSet({
                  awardingBody: e.target.value
                });
              }
            }} />

          <FormFooter>
            <Button
              type={'button'}
              classes={['button', 'button--style-blue']}
              onClick={(e) => {
                this.props.handleSaveManualQualification(e);
                this.props.handleSetStep(e, STEP_QUALIFICATION_VIEW);
              }}
              disabled={!this.props['qualificationTitle_' + this.props.inputLanguage] || !this.props['qualificationType']}>
              {this.props.t('local:view.courses.create.tabs.qualifications.step.create.field.callToAction')}
            </Button>
          </FormFooter>
        </Form>
        <FormFooter>
          <FormBack
            onClick={(e) => {
              this.props.handleSetStep(e, STEP_QUALIFICATION_VIEW);
              this.props.handleClearManualQualification();
              this.props.handleScrollTop();
            }}>
            {this.props.t('local:view.courses.create.tabs.qualifications.step.create.callToAction')}
          </FormBack>
        </FormFooter>
      </Fragment>
    );
  }

}

export default withAssets(withTranslation('local')(QualificationsCreateStep));
